import { render, staticRenderFns } from "./scheduleShiftDay.vue?vue&type=template&id=220f5889&scoped=true"
import script from "./scheduleShiftDay.vue?vue&type=script&lang=js"
export * from "./scheduleShiftDay.vue?vue&type=script&lang=js"
import style0 from "./scheduleShiftDay.vue?vue&type=style&index=0&id=220f5889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f5889",
  null
  
)

export default component.exports